import { useEffect } from "react";

export default function TaloChatWidget({ token, position = "right" }) {
  useEffect(() => {
    if (!token) return;

    // Prevent double load
    if (document.getElementById("talo-chat-script")) return;

    // Inject config
    window.TALO_CHAT = {
      token,
      position,
      origin: window.location.origin,
    };

    // Inject script
    const script = document.createElement("script");
    script.src = "https://talo.digiport.online/widget.js";
    script.async = true;
    script.id = "talo-chat-script";

    document.body.appendChild(script);

    return () => {
      // Optional cleanup
      document.body.removeChild(script);
      delete window.TALO_CHAT;
    };
  }, [token, position]);

  return null; // Widget renders outside React tree
}
